import { motion, useInView, useMotionValue, useTransform, animate } from 'framer-motion';
import { useEffect, useRef } from 'react';
import { stats } from '../../../data/stats';
import { Reveal } from '../../ui/Reveal/Reveal';
import './Stats.css';

function CountUp({ value }: { value: string }) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, { once: true, margin: '-50px' });
  const motionValue = useMotionValue(0);
  const target = parseFloat(value);
  const display = useTransform(motionValue, (n) =>
    value.includes('.') ? n.toFixed(1) : Math.floor(n).toString()
  );

  useEffect(() => {
    if (inView) {
      const controls = animate(motionValue, target, {
        duration: 2.2,
        ease: [0.16, 1, 0.3, 1],
      });
      return controls.stop;
    }
  }, [inView, motionValue, target]);

  return <motion.span ref={ref}>{display}</motion.span>;
}

export function Stats() {
  return (
    <section className="section stats">
      <div className="container">
        <div className="stats__grid">
          {stats.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className="stat">
                <div className="stat__value">
                  <CountUp value={s.value} />
                  {s.suffix && <span className="stat__suffix">{s.suffix}</span>}
                </div>
                <div className="stat__rule" />
                <div className="stat__label">{s.label}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
